export class ConversationRecordEditData {
    id: number = undefined;
    title: string;
    text: string;
    domainIds: number[];
}